import {ViewStream} from 'spyne';
import PageConfigHeadTmpl from './templates/page-configurator-head.tmpl.html'
import { PageDocItemsTraits} from 'traits/page-doc-items-traits';
import { PageDocsItemBlock  } from 'components/pages/page-docs-item-block';

export class PageConfiguratorHeading extends ViewStream {

    constructor(props={}) {
        props.id = 'page-configurator-heading';
        props.traits = [PageDocItemsTraits];
        props.template = PageConfigHeadTmpl;

        super(props);
    }

    addActionListeners() {
        // return nexted array(s)
        return [];
    }

    broadcastEvents() {
        // return nexted array(s)
        return [];
    }

    onAddDocItems(){

      const onAddITem = (data)=>{

        this.appendView(new PageDocsItemBlock({data}));;
      }

      this.props.data?.block.forEach(onAddITem);;
    }

    onRendered() {

      this.onAddDocItems();;
     //console.log('RENDERED CONFIG HEADING ',this.props);

    }

}

